import { Action } from 'redux';
import { isType } from 'typescript-fsa';
import {
	clearLoggedInMessage,
	ILoggedInMessage,
	INoticeMessage,
	setLoggedInMessage,
	setLoginManagerNotice,
	setPasswordChangeSuccess,
	showLoginProgress,
} from '../actions/login';
import { setAccessURL } from '../actions/loginSso';

/**
 * ログイン画面のState型
 */
export interface ILoginSsoState {
	/** アクセスURL */
	readonly accessURL: string;
	/** お知らせカルーセルのスライド間隔 */
	readonly carouselChangeInterval: number;
	/** お知らせデータ取得日時 */
	readonly fetchedMessagesAt?: Date;
	/** プログレス表示フラグ */
	readonly isShowProgress: boolean;
	/** お知らせデータリスト */
	readonly messages: INoticeMessage[];
	/** ログイン後メッセージ */
	readonly loggedInMessage: ILoggedInMessage;
	/** パスワード変更成功フラグ */
	readonly passwordChangeSuccess: boolean;
}

/**
 * ログイン画面のState初期値
 */
const initialState: ILoginSsoState = {
	accessURL: '',
	carouselChangeInterval: 10000,
	isShowProgress: false,
	loggedInMessage: {
		displayContentsLicenseInfoMessage: false,
		displayDesktopMessageDialog: false,
		displayLastLoginIPAddress: false,
		displayLastLoginInfo: false,
		displaySecuritySamePwdWarningMessage: false,
	},
	messages: [],
	passwordChangeSuccess: false,
};

/**
 * ログイン画面用reducer
 * @param state ログイン情報
 * @param action アクション
 */
const loginSso = (state = initialState, action: Action) => {
	if (isType(action, setAccessURL)) {
		return {
			...state,
			accessURL: action.payload.accessURL,
		};
	}

	if (isType(action, showLoginProgress)) {
		return {
			...state,
			isShowProgress: action.payload.isShowProgress,
		};
	}

	if (isType(action, setLoginManagerNotice)) {
		return {
			...state,
			carouselChangeInterval: action.payload.carouselChangeInterval,
			fetchedMessagesAt: new Date(),
			messages: action.payload.messages,
		};
	}

	if (isType(action, setLoggedInMessage)) {
		return {
			...state,
			loggedInMessage: {
				...action.payload,
			},
		};
	}

	if (isType(action, clearLoggedInMessage)) {
		return {
			...state,
			loggedInMessage: {
				...initialState.loggedInMessage,
			},
		};
	}

	if (isType(action, setPasswordChangeSuccess)) {
		return {
			...state,
			passwordChangeSuccess: action.payload.passwordChangeSuccess,
		};
	}

	return state;
};

export default loginSso;



// WEBPACK FOOTER //
// ./src/reducers/loginSso.ts